import * as React from "react";
import _ from "lodash";

import { AgentGroup } from "../../shared/model/AgentGroup";
import { ProcessVersionDetails } from "../model/ProcessVersion";
import Select from "shared/components/select/Select";
import { Utilities } from "shared/utilities";
import { Option } from "shared/model/Option";

export const VersionSelectorDropdown: React.FC<VersionSelectorDropDownProps> = (props) => {

    const getVersionMenuItem = (v: ProcessVersionDetails): Option<number> => {
        const versionString = props.getVersionString(v);
        const deployedAgentGroups = v.deployedToAgentGroups && v.deployedToAgentGroups.length > 0
            ? v.deployedToAgentGroups.map((name) => {
                const foundAgentGroup = props.agentGroups.find((f) => f.name === name)
                if (foundAgentGroup != null) {
                    return foundAgentGroup.displayName;
                }
                return name;
            }).join(", ")
            : null;
        return {
            label: `${versionString}${deployedAgentGroups !== null ? " - " + deployedAgentGroups : ""}`,
            value: v.version
        }
    };

    const handleSelect = (newVersion: Option) => {
        if (props.onSelectVersion !== undefined) {
            props.onSelectVersion(props.processGuid, newVersion.value);
        }
    };

    const alreadyDeployedVersions = props.versionRows.filter((v) => v.deployedToAgentGroups && v.deployedToAgentGroups.length > 0);
    const notDeployedVersions = props.versionRows.filter((v) => !v.deployedToAgentGroups || v.deployedToAgentGroups.length === 0);
    const selectedVersion = props.versionRows.find((v) => v.version === props.selectedVersion);

    const options: Option[] = [
        ...alreadyDeployedVersions.map((v) => getVersionMenuItem(v)),
        ...notDeployedVersions.map((v) => getVersionMenuItem(v))
    ]

    return (
        <Select
            id={`version-selector-${props.processGuid}`}
            classNamePrefix="react-select"
            value={Utilities.valueFromId(options, selectedVersion?.version)}
            options={options}
            onChange={handleSelect}
            menuPlacement="auto"
            menuPortalTarget={document.body}
        />
    );
};

interface VersionSelectorDropDownProps {
    processGuid: string;
    selectedVersion: number;
    agentGroups: AgentGroup[];
    versionRows: ProcessVersionDetails[];
    onSelectVersion: ((processGuid: string, version: number) => void) | undefined;
    getVersionString: (processVersionDetails: ProcessVersionDetails | undefined) => string;
}
